import { useEffect, useState } from "react";

// Палитра дашборда /clicks. recharts не наследует CSS -> резолвим hex здесь и
// передаём в stroke/fill явно. Тёмная тема — спроектированная (не авто-флип),
// переключается по классу `dark` на <body> (как остальная админка).
// Валидировано dataviz-валидатором (CVD ΔE 41-47, lightness/chroma pass).
export interface Tokens {
  isDark: boolean;
  // метрики (цвет следует за метрикой, не за рангом)
  impr: string;
  pos: string;
  ctr: string;
  clicks: string;
  // статусы/акценты
  opp: string;
  good: string;
  bad: string;
  // ординальная синяя лесенка страниц SERP: [page1..page4], page1 самый заметный
  bucket: [string, string, string, string];
  // поверхности и чернила
  pagePlane: string;
  card: string;
  cardAlt: string;
  ink: string;
  ink2: string;
  muted: string;
  grid: string;
  axis: string;
  border: string;
}

const LIGHT: Tokens = {
  isDark: false,
  impr: "#2a78d6",
  pos: "#158a5f",
  ctr: "#b87e00",
  clicks: "#4a3aa7",
  opp: "#e39400",
  good: "#0ca30c",
  bad: "#d03b3b",
  bucket: ["#1e5fbf", "#4a86d6", "#86b0e5", "#c2d6ef"],
  pagePlane: "#f6f6f3",
  card: "#ffffff",
  cardAlt: "#faf9f6",
  ink: "#0b0b0b",
  ink2: "#52514e",
  muted: "#8b8983",
  grid: "#e6e5de",
  axis: "#c3c2b7",
  border: "#e8e7e0",
};

const DARK: Tokens = {
  isDark: true,
  impr: "#3987e5",
  pos: "#22b982",
  ctr: "#e0a83a",
  clicks: "#9085e9",
  opp: "#fab219",
  good: "#2bbf2b",
  bad: "#e2564f",
  bucket: ["#5fa0f0", "#3f7bcf", "#2f5a94", "#28425f"],
  pagePlane: "#0d0d0c",
  card: "#1a1a19",
  cardAlt: "#201f1d",
  ink: "#f5f5f2",
  ink2: "#c3c2b7",
  muted: "#8b8983",
  grid: "#2c2c2a",
  axis: "#3a3a37",
  border: "#2c2c2a",
};

export function useThemeTokens(): Tokens {
  const read = () =>
    typeof document !== "undefined" &&
    document.body.classList.contains("dark");
  const [dark, setDark] = useState<boolean>(read());

  useEffect(() => {
    const obs = new MutationObserver(() => setDark(read()));
    obs.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => obs.disconnect();
  }, []);

  return dark ? DARK : LIGHT;
}
